import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { values } from "./utils";
import moment from "moment";
import { store } from "../../../../redux/storeConfig/store";
import * as XLSX from "xlsx-js-style";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// const XLSX = window.XLSX;

const columnsLabels = {
  members: {
    members: [
      "ID",
      "Name",
      "Email",
      "Mobile",
      "Member Registerd By",
      "Total Spent",
      "Member Status",
      "Joining Date",
      "Last Updating Date",
      "isMemberDeleted",
      "Created By",
      "Member Created Branch",
      "Waver Signed"
    ],
    memberships: [
      "Member",
      "Member Phone",
      "Member Email",
      "Member Date of Birth",
      "Member Status",
      "Package",
      "Starts",
      "Ends",
      "Status",
      "isMemberDeleted",
      "Check-ins",
      "Created By"
    ],
  },
  revenue: {
    "PT subscriptions Revenue": [
      "Member",
      "Service",
      "Created Date",
      "Start Date",
      "End Date",
      "Type",
      "Price",
      "Discount",
      "Tax (%)",
      "Net Rev.",
      "Booked Sessions",
      "Completed Sessions",
      "Attended Sessions ",
      "Remaining",
      "Earned from Completed Sessions $",
      "Earned Value (from Attended) Sessions $",
      "Deffered from Completed Sessions $",
      "Deffered (from Attended) Sessions $",
      "Instructor Name",
      "Notes",
      "isMemberDeleted",
      "Tax amount",
    ],
    "Gym subscriptions Revenue":[
      "Member",
      "Service",
      "Created Date",
      "Start Date",
      "End Date",
      "Type",
      "Price",
      "Discount",
      "Tax (%)",
      "Net Rev.",
      "Used",
      "Remaining",
      "Earned $",
      "Deffered $",
      "Notes",
      "isMemberDeleted",
      "Tax amount",
    ],
    "Class subscriptions Revenue": [
      "Member",
      "Service",
      "Created Date",
      "Start Date",
      "End Date",
      "Type",
      "Price",
      "Discount",
      "Tax (%)",
      "Net Rev.",
      "Used",
      "Remaining",
      "Earned $",
      "Deffered $",
      "Instructor Name",
      "Class Name",
      "Notes",
      "isMemberDeleted",
      "Tax amount",
    ],
  },
  sales: {
    sales: [
      "Sale Date",
      "Time",
      "Client",
      "Ref ID",
      "Package",
      "Quantity",
      `Price`,
      `Subtotal`,
      "Cost",
      "Payment Type",
      "Category",
      `Discount`,
      `Tax`,
      "Net",
      "Notes",
      "isMemberDeleted",
      "Joining Fees",
      "Assigned Sale Produt",
      "Created By",
      "Trainer",
    ],
  },
  retention: {
    retention: ["Instructor Name", "Service", "Service Type", "Total Members"],
  },
  AccountBalance: {
    AccountBalance: [
      "Client Name",
      "OutStanding Balance",
      "Received Amount",
      "Total Payment Due",
      "isMemberDeleted",
    ],
  },
  staff: {
    "Staff Log": ["Staff Name","Date","Day", "Check in", "Check out"],
  },
  "attendence analysis": {
    Classes: ["Name", "Day(Time)", "Total members"],
    Instructor: ["Instructor Name", "Service", "Service Type", "Total Members"],
    Gym: ["Time", "number of checkins"],
  },
  booking: {
    Booking: ["Instructor Name", "Service", "Service Type", "Total Members"],
  },
  transaction: {
    "Transaction Log": [
      "id",
      "membership",
      "Start Subscription",
      "End Subscription",
      "purpose",
      "note",
      "isMemberDeleted",
      "type",
      "financial party",
      "amount",
      "Created By",
      "Created At",
    ],
  },
  "canceled memberships": {
    "Canceled Memberships Log": [
      "id",
      "Member",
      "Package",
      "Price",
      "Receieved Amount",
      "Voided Amount",
      "Canceled Date",
      "Canceled By",
      "isMemberDeleted",

    ],
  },
  staffSessions: {
    "Staff Sessions": [
      "ID",
      "Staff Name",
      "Cash",
      "Status",
      "Start Date",
      "End Date",
      "Start Time",
      "End Time",
      "Cash At Start",
      "Cash At End",
      "Cash Confirmed Amount",
      "Net Transactions",
      "Total In Cash",
      "Difference In Cash",
      "Balance Issue Reason",
      "Closed By",
      "Assigned To Confirm",
      "Confirmed By",
    ],
  },
};
const getAccountEntryColumnsLabels = (category) => {
  const columns = {
    subscriptions: [
      "total_subscriptions",
      "total_received_amount",
      "total_remaining_amount",
      "total_discount",
      "total_voided_amount",
      "total_complimantry",
      "total_cash",
      "total_visa",
      "total_bank",
      "total_void_cash",
      "total_void_visa",
      "total_void_bank",
      "total_net_revenue",
    ],

    pt: [
      "total_subscriptions",
      "total_received_amount",
      "total_remaining_amount",
      "total_discount",
      "total_voided_amount",
      "total_complimantry",
      "total_cash",
      "total_visa",
      "total_bank",
      "total_void_cash",
      "total_void_visa",
      "total_void_bank",
      "total_net_revenue",
    ],

    jf: [
      "total_subscriptions",
      "total_received_amount",
      "total_remaining_amount",
      "total_discount",
      "total_voided_amount",
      "total_cash",
      "total_visa",
      "total_bank",
      "total_net_revenue",
    ],

    retail: [
      "total_subscriptions",
      "total_received_amount",
      "total_returned_amount",
      "total_remaining_amount",
      "total_discount",
      "total_complimantry",
      "total_voided_amount",
      "total_cash",
      "total_visa",
      "total_bank",
      "total_net_revenue",
    ],
  };

  return columns[category] || [];
};
const accountingEntryValues = {
  accountingEntry: {
    subscriptions: {
      total_subscriptions: (row) => row.total_subscriptions || 0,
      total_received_amount: (row) => row.total_received_amount || 0,
      total_remaining_amount: (row) => row.total_remaining_amount || 0,
      total_discount: (row) => row.total_discount || 0,
      total_voided_amount: (row) => row.total_voided_amount || 0,
      total_complimantry: (row) => row.total_complimantry || 0,
      total_cash: (row) => row.total_cash || 0,
      total_visa: (row) => row.total_visa || 0,
      total_bank: (row) => row.total_bank || 0,
      total_void_cash: (row) => row.total_void_cash || 0,
      total_void_visa: (row) => row.total_void_visa || 0,
      total_void_bank: (row) => row.total_void_bank || 0,
      total_net_revenue: (row) => row.total_net_revenue || 0,
    },

    pt: {
      total_subscriptions: (row) => row.total_subscriptions || 0,
      total_received_amount: (row) => row.total_received_amount || 0,
      total_remaining_amount: (row) => row.total_remaining_amount || 0,
      total_discount: (row) => row.total_discount || 0,
      total_voided_amount: (row) => row.total_voided_amount || 0,
      total_complimantry: (row) => row.total_complimantry || 0,
      total_cash: (row) => row.total_cash || 0,
      total_visa: (row) => row.total_visa || 0,
      total_bank: (row) => row.total_bank || 0,
      total_void_cash: (row) => row.total_void_cash || 0,
      total_void_visa: (row) => row.total_void_visa || 0,
      total_void_bank: (row) => row.total_void_bank || 0,
      total_net_revenue: (row) => row.total_net_revenue || 0,
    },

    jf: {
      total_subscriptions: (row) => row.total_subscriptions || 0,
      total_received_amount: (row) => row.total_received_amount || 0,
      total_remaining_amount: (row) => row.total_remaining_amount || 0,
      total_discount: (row) => row.total_discount || 0,
      total_voided_amount: (row) => row.total_voided_amount || 0,
      total_cash: (row) => row.total_cash || 0,
      total_visa: (row) => row.total_visa || 0,
      total_bank: (row) => row.total_bank || 0,
      total_net_revenue: (row) => row.total_net_revenue || 0,
    },

    retail: {
      total_subscriptions: (row) => row.total_subscriptions || 0,
      total_received_amount: (row) => row.total_received_amount || 0,
      total_returned_amount: (row) => row.total_returned_amount || 0,
      total_remaining_amount: (row) => row.total_remaining_amount || 0,
      total_discount: (row) => row.total_discount || 0,
      total_complimantry: (row) => row.total_complimantry || 0,
      total_voided_amount: (row) => row.total_voided_amount || 0,
      total_cash: (row) => row.total_cash || 0,
      total_visa: (row) => row.total_visa || 0,
      total_bank: (row) => row.total_bank || 0,
      total_net_revenue: (row) => row.total_net_revenue || 0,
    },
  },
};

// let gymName=store.getState().gym?.user?.name

export class ReportExportBootstrap {
  constructor(reportName, data, currentTab, fromDate, toDate, gymName,extraColsForExport) {
    this.reportName = reportName;
    this.data = data;
    this.currentTab = currentTab;
    this.fromDate = fromDate;
    this.toDate = toDate;
    this.gymName = gymName;
    this.extraColsForExport=extraColsForExport
  }
  
  getColumnsLabels = () => [...columnsLabels[this.reportName][this.currentTab],...this.extraColsForExport?.colsForExport];

  //Excel Starts Here

  transposeRowsToCols = (arr) => {
    const rawTransposed = [];

    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr[i].length; j++) {
        if (!rawTransposed[j]) rawTransposed[j] = [];
        rawTransposed[j][i] = arr[i][j];
      }
    }

    return rawTransposed;
  };

  exportToExcel() {
    const sheetName = "Sheet1";
    let excelFileName = `${this.currentTab}-${moment().format(
      "DD-MM-YYYY hh:mm:ss"
    )}.xlsx`;

    console.log({ f: this.fromDate, to: this.toDate });
    if (this.fromDate && this.toDate && this.gymName)
      excelFileName = `${this.gymName}: ${this.currentTab} from -${moment(
        this.fromDate
      ).format("DD-MM-YYYY")} to-${moment(this.toDate).format(
        "DD-MM-YYYY"
      )}.xlsx`;
    const filename = excelFileName;
    const reportLabels = this.getColumnsLabels();

    let exportedData = reportLabels.map((i) =>
      this.data.map((row) => {
       let exportValues =values
      if (this.extraColsForExport?.valuesForExport && 
          Object.keys(this.extraColsForExport.valuesForExport).length) {
        exportValues = {
          ...values,
          [this.reportName]: {
            ...values[this.reportName],
            [this.currentTab]: {
              ...values[this.reportName][this.currentTab],
              ...this.extraColsForExport.valuesForExport, // inject safely
            }
          }
        };
      }

      return exportValues[this.reportName][this.currentTab][i]
        ? exportValues[this.reportName][this.currentTab][i](row)
        : "";

      })
    );

    for (let idx in exportedData) {
      exportedData[idx].unshift(reportLabels[idx]);
    }

    const transposed = this.transposeRowsToCols(exportedData);
    if (this.reportName === "revenue" && this.currentTab === "PT subscriptions Revenue") {
      // Compute totals
      const totalBookedSessions = this.data.reduce((s, r) => s + ((r.usedSessions) || 0), 0);
      const totaCompletedSessions = this.data.reduce((s, r) => s + ((r.completedBookingsCount) || 0), 0);
      const totaAttendedSessions = this.data.reduce((s, r) => s + ((r.checkedInCount) || 0), 0);
      const totalEarnedCompleted = this.data.reduce((s, r) => s + ((r.earned) || 0), 0);
      const totalEarnedAttended = this.data.reduce((s, r) => s + ((r.earnedFromCheckIn) || 0), 0);
      const totalDeferredCompleted = this.data.reduce((s, r) => s + ((r.deffered) || 0), 0);
      const totalDeferredAttended = this.data.reduce((s, r) => s + ((r.defferedFromCheckIn) || 0), 0);

      // Add empty row and totals row
      transposed.push([]);
      transposed.push([
        "TOTALS",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        totalBookedSessions,
        totaCompletedSessions,
        totaAttendedSessions,
        "",
        totalEarnedCompleted,
        totalEarnedAttended,
        totalDeferredCompleted,
        totalDeferredAttended,
      ]);
    }
    if (this.reportName === "sales") {
      const totalQuantity = this.data.reduce((s, r) => s + (Number(r.quantity) || 0), 0);
      const totalPrice = this.data.reduce(
        (s, r) =>
          s +
          Number(
            (r?.paymentType === "CO" ? r?.packagePrice : r.purchasedPackagePrice) * (r.quantity || 0)
          ),
        0
      );
      const totalSubtotal = this.data.reduce(
        (s, r) =>
          s +
          Number(
           r.purchasedPackagePrice * r.quantity -
              ((r.purchasedPackagePrice * r.quantity * r.discount) / 100)
          ),
        0
      );
      const totalDiscount = this.data.reduce(
        (s, r) =>
          s +
          Number(
            ((r?.paymentType === "CO" ? 100 : r.discount || 0) *
              (r?.paymentType === "CO" ? r?.packagePrice : r.purchasedPackagePrice || 0) *
              (r.quantity || 0)) /
              100
          ),
        0
      );
      const totalTax = this.data.reduce(
        (s, r) =>
          s +
          Number(
          ( r.purchasedPackagePrice *
              r.quantity *
              (1 - r.discount / 100)) * (1 - 1 / (1 + r.tax / 100))
          ),
        0
      );
      const totalNet = this.data.reduce(
        (s, r) =>
          s +
         ((r.purchasedPackagePrice *
              r.quantity *
              (1 - r.discount / 100)) - (( r.purchasedPackagePrice *
              r.quantity *
              (1 - r.discount / 100)) * (1 - 1 / (1 + r.tax / 100)))),
        0
      );
      const totalCost = this.data.reduce((s, r) => s + (Number(r.cost) || 0), 0);
      const totalJoiningFees = this.data.reduce((s, r) => s + (Number(r.joiningFees) || 0), 0);

      // Add empty row for spacing
      transposed.push([]);

      // Add totals row
      const totalsRow = [
        "TOTALS", // Sale Date
        "", // Time
        "", // Client
        "", // Ref ID
        "", // Package/Product
        totalQuantity, // Quantity
        totalPrice.toFixed(2), // Price
        totalSubtotal.toFixed(2), // Subtotal
        totalCost.toFixed(2), 
        "",
        "",
        totalDiscount.toFixed(2), 
        totalTax.toFixed(2), 
        totalNet.toFixed(2), // Net
        "", // Notes,
        "", // isMemberDeleted
        totalJoiningFees.toFixed(2), // Joining Fees
        "", // Assigned Sale Product
        "", // Created By
        "", // Trainer
      ];

      transposed.push(totalsRow);
    }
    const worksheet = XLSX.utils.aoa_to_sheet(transposed);
    if (this.reportName === "revenue" && this.currentTab === "PT subscriptions Revenue"||this.reportName === "sales") {
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      const lastRow = range.e.r; // last row index (0-based)
      for (let C = 0; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: lastRow, c: C });
        if (!worksheet[cellRef]) continue;
        worksheet[cellRef].s = {
          fill: { fgColor: { rgb: "E0E0E0" } }, // light gray background
          font: { bold: true },
        };
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    XLSX.writeFile(workbook, filename);
  }
  exportToExcelMultipleTabs() {
    let excelFileName = `accounting-entry-report-${moment().format(
      "DD-MM-YYYY hh:mm:ss"
    )}.xlsx`;

    if (this.fromDate && this.toDate && this.gymName)
      excelFileName = `${this.gymName}:accounting-entry-report from -${moment(
        this.fromDate
      ).format("DD-MM-YYYY")} to-${moment(this.toDate).format(
        "DD-MM-YYYY"
      )}.xlsx`;
    const filename = excelFileName;
    const workbook = XLSX.utils.book_new();

    // Create sheets for each category
    const categories = ["subscriptions", "pt", "jf", "retail"];

    // Process each category
    categories.forEach((category) => {
      const reportLabels = getAccountEntryColumnsLabels(category);

      // Get data for the category
      const categoryData = this.data.filter((row) => row.category === category);


      //   // Create data rows for the category
      let exportedData = reportLabels.map((label) =>
        categoryData.map((row) =>
          accountingEntryValues[this.reportName][category][label](row)
        )
      );

      //   // Add labels as first row
      for (let idx in exportedData) {
        exportedData[idx].unshift(reportLabels[idx]);
      }

      //   // Transpose data
      const transposed = this.transposeRowsToCols(exportedData);

      //   // Add totals row
      const totalsRow = [
        ["Totals"],
        ["Total Subscriptions", categoryData[0]?.total_subscriptions || 0],
        ["Total Received Amount", categoryData[0]?.total_received_amount || 0],
        ["Total Returned Amount", categoryData[0]?.total_returned_amount || 0],
        [
          "Total Remaining Amount",
          categoryData[0]?.total_remaining_amount || 0,
        ],
        ["Total Discount", categoryData[0]?.total_discount || 0],
        ["Total Voided Amount", categoryData[0]?.total_voided_amount || 0],
        ["Total Complimentary", categoryData[0]?.total_complimantry || 0],
        ["Total Cash", categoryData[0]?.total_cash || 0],
        ["Total Visa", categoryData[0]?.total_visa || 0],
        ["Total Bank", categoryData[0]?.total_bank || 0],
        ["Total Net Revenue", categoryData[0]?.total_net_revenue || 0],
      ];

      //   // Add some space and then add totals
      transposed.push([]); // Empty row for spacing
      totalsRow.forEach((row) => transposed.push(row));

      //   // Create worksheet and add to workbook
      const worksheet = XLSX.utils.aoa_to_sheet(transposed);

      //   // Customize column widths
      const columnWidths = reportLabels.map(() => ({ wch: 15 }));
      worksheet["!cols"] = columnWidths;

      //   // Add the worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, category.toUpperCase());
    });

    // // Create Summary sheet
    const summaryData = [
      ["Summary Report"],
      [],
      ["Category", "Subscriptions", "PT", "JF", "Retail", "Total"],
      [
        "Total Subscriptions",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)
              ?.total_subscriptions || 0
        ),
      ],
      [
        "Total Received",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)
              ?.total_received_amount || 0
        ),
      ],
      [
        "Total Remaining",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)
              ?.total_remaining_amount || 0
        ),
      ],
      [
        "Total Discount",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)?.total_discount || 0
        ),
      ],
      [
        "Total Voided",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)
              ?.total_voided_amount || 0
        ),
      ],
      [
        "Total Returned",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)
              ?.total_returned_amount || 0
        ),
      ],
      [
        "Total Cash",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)?.total_cash || 0
        ),
      ],
      [
        "Total Visa",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)?.total_visa || 0
        ),
      ],
      [
        "Total Bank",
        ...categories.map(
          (cat) =>
            this.data.find((row) => row.category === cat)?.total_bank || 0
        ),
      ],
      // [
      //   "Net Revenue",
      //   ...categories.map(
      //     (cat) =>
      //       this.data.find((row) => row.category === cat)?.grand_total_net ||
      //       0
      //   ),
      // ],
    ];

    const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
    summarySheet["!cols"] = [
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
    ];
    XLSX.utils.book_append_sheet(workbook, summarySheet, "SUMMARY");

    // Write the file
    XLSX.writeFile(workbook, filename);
  }

  // PDF Starts Here

  pdfDocDefinition = () => {
    return {
      pageSize: "A3",
      pageOrientation: "portrait",
      pageBreakBefore: (currentNode, followingNodesOnPage) => {
        return (
          currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0
        );
      },
      content: [
        {
          text: "Connect To Fit",
          style: "title",
          alignment: "center",
        },
        // Table Starts Here
        {
          table: {
            headerRows: 1,
            widths: "*",
            body: [
              this.getColumnsLabels().map((label) => {
                return { text: label, style: "tableHeader" };
              }),
              this.getColumnsLabels().map((i) =>
                this.data.map((row) =>
                  values[this.reportName][this.currentTab][i](row)
                )
              ),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return "#ffffff";
            },
            vLineColor: function (i, node) {
              return "#ffffff";
            },
            fillColor: function (rowIndex) {
              if (rowIndex === 0) return rowIndex % 2 === 0 ? "#2d4154" : null;
              return rowIndex % 2 === 0 ? "#ffffff" : "#f3f3f3";
            },
          },
        },
      ],
      // Table Ends Here
      styles: {
        tableHeader: { fontSize: 12, bold: true, color: "white" },
        creatorTitle: {
          margin: [0, 0, 0, 35],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 15],
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 13, 0, 5],
        },
        content: {
          fontSize: 14,
          bold: false,
          // margin: [0, 13, 0, 5],
        },
        metricTitle: {
          fontSize: 16,
          bold: false,
          margin: [0, 10, 0, 5],
        },
        title: {
          fontSize: 28,
          bold: true,
          margin: [0, 10, 0, 25],
        },
      },
    };
  };

  downloadPDF = () => {
    pdfMake.createPdf(this.pdfDocDefinition()).download();
  };
}
